export default "/images/19fc8b9350751794c15faeb75dfea284.avif";